import "../styles/MisCuestionarios.css";
import React, { useContext } from "react";
import { Container, Stack, Box, Typography } from "@mui/material";
import ContinuarCuestionario from "../components/ContinuarCuestionario";
import { MisCuestionariosContext } from "../context/MisCuestionariosContext";
import { useTranslation } from "react-i18next";
import { GeneralContext } from "../context/GeneralContext";
import { useSecurity } from "../hooks/useSecurity"
import { ContinuarCuestionarioSkeleton } from "../components/commons/ContinuarCuestionarioSkeleton";
import { CuestionarioHistoricoSkeleton } from "../components/commons/CuestionarioHistoricoSkeleton";
import { AccordionPerfilEmpresarial } from "../components/AccordionPerfilEmpresarial";

export function MisCuestionarios() {
    const {
        perfilesEmpresarialesHistoricos,
        loadingCuestionarioActual,
        loadingCuestionariosHistoricos
    } = useContext(MisCuestionariosContext);
    const { t } = useTranslation();
    const { } = useContext(GeneralContext);
    const { } = useContext(MisCuestionariosContext);
    useSecurity();



    return (
        <>
            <Stack direction="column" justifyContent="center" alignItems="center" spacing={2}>
                <Box className="textCard" sx={{ width: '100%' }}>
                    {loadingCuestionarioActual ? (
                        <ContinuarCuestionarioSkeleton />
                    ) : (
                        <ContinuarCuestionario />
                    )}
                </Box>
                <Box>
                    <Typography variant="h1">{t("misCuestionarios.historico")}</Typography>
                </Box>
                {loadingCuestionariosHistoricos ? (
                    <CuestionarioHistoricoSkeleton />
                ) : (
                    <>
                        {perfilesEmpresarialesHistoricos && perfilesEmpresarialesHistoricos.length > 0 ? (
                            perfilesEmpresarialesHistoricos.map((PerfilEmpresarial, index) => (
                                <AccordionPerfilEmpresarial key={index} PerfilEmpresarial={PerfilEmpresarial} />
                            ))
                        ) : (
                            <Typography paddingLeft={1} variant="overline">
                                {t("misCuestionarios.nofinalizados")}
                            </Typography>
                        )}
                    </>
                )}
            </Stack>
        </>
    );
}
